import { actionDuckUtils } from 'wanderu-ducks-utils';

import sliceNamespace from '../../types';

const namespace = 'FETCH_TRIP';
const {
    actions,
    reducer,
    selectors: baseSelectors,
} = actionDuckUtils.buildBaseDuck(namespace, sliceNamespace);

function selectNotFound(appState, tripId) {
    const error = baseSelectors.selectError(appState, tripId);
    return error && error.code === 'TRIPS_NOT_FOUND';
}

const selectors = {
    ...baseSelectors,
    selectNotFound,
};

export {
    actions,
    namespace,
    reducer,
    selectors,
};
